import { StyleSheet } from 'aphrodite/no-important';

import colors from '../../identity/colors';
import typeContent from '../../identity/type';

export default StyleSheet.create({
  li: {
    color: colors.GREY_NO_70,
    ...typeContent.SMALL,
    fontWeight: 100,
    position: 'relative',
    lineHeight: '40px',
    paddingRight: '42px',
    borderRight: '5px solid #666e791a',
    transition: 'border-right-color 350ms ease-out .5s, opacity 350ms ease-out .5s',
  },

  a: {
    textDecoration: 'none',
    color: colors.GREY_NO_70,
    fontWeight: 400,
    opacity: '.4',
    transition: 'color 350ms ease-out .5s, opacity 350ms ease-out .5s',
  },

  textHighlight: {
    color: '#4267B2 !important',
    opacity: 1,
  },
});



// WEBPACK FOOTER //
// ./src/components/NavigationListItem/styles.js